import { Box, Text } from "@chakra-ui/react";
import React from "react";

const SectionTitle = ({ title }) => {
  return (
    <Box mb="1.75rem">
      <Text
        as="h2"
        size="header"
        variant="secondary"
        fontSize="28px"
        pb="0.5rem"
      >
        {title}
      </Text>
      <Box
        w="40px"
        h="5px"
        borderRadius="3px"
        bg="linear-gradient(to right,#ffdb70,#ffbb5c)"
      />
    </Box>
  );
};

export default SectionTitle;
